export default __webpack_public_path__ + "static/media/ic-subscriptions.ab51c350.svg";